import { getCaseTypes } from "helpers/localStorage";
import { useState } from "react";

const caseTypes = getCaseTypes() || [];

const useCaseTypeSelectState = (initial = caseTypes[0]?.id || -1) =>
  useState(initial);

export default useCaseTypeSelectState;
